




















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import PaginationComponent from '@/shared/pagination.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import MobileHandler from '@/shared/utils/mobile-handler';
import splitContent from '@/shared/directive/split-content';
import DateHandler from '@/shared/utils/date-format';
import Header from './header.json';

@Component({
  components: { PaginationComponent, LabelSlot },
  filters: {
    splitContent,
    formatDate(value: string) {
      return DateHandler.timestampToLocal(value.split('T')[0]);
    },
  },
})
export default class TableComponent extends Vue {
  @Prop() items!: any[];

  @Prop() loading!: boolean;

  @Prop() page!: any;

  @Prop({ type: Array, default: () => [] })
  extraColumns!: any[];

  @Prop({
    type: Boolean,
    default: false,
  }) hasReadPersonalDataAuthority!: boolean;

  header: any[] = Header;

  headersWithPersonalData: any[] = [
    ...Header.filter(header => header.value !== 'expandir'),
    {
      text: 'Cidade',
      value: 'city',
      sortable: false,
      align: 'center',
    },
    {
      text: 'Expandir',
      value: 'expandir',
      class: 'data-table-header',
    },
  ];

  isMobile = false;

  updateTable(pagination: any): void {
    this.$emit('update', pagination);
  }

  onResize() {
    this.isMobile = MobileHandler.isMobile();
  }

  select(item: any): void {
    this.$router.push({
      path: `/profile/${item.username}/`,
    });
  }

  toggleExpansion(item: any): void {
    this.$set(item, 'expanded', !item.expanded);
  }

  get tableHeaders() {
    return this.hasReadPersonalDataAuthority
      ? this.headersWithPersonalData
      : this.header;
  }
}
